import {TFunction} from "i18next";
import {TransactionLogPayload} from "../types/Responses/TransactionsResponse";

const isLikelyJsonStructure = (value: string) => {
    const trimmed = value.trim();
    return (
        (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
        (trimmed.startsWith("[") && trimmed.endsWith("]"))
    );
};

export const formatTransactionLogPayload = (payload: TransactionLogPayload): string => {
    if (!payload) {
        return '';
    }

    if (typeof payload === 'string') {
        if (!payload.trim()) {
            return '';
        }
        if (isLikelyJsonStructure(payload)) {
            try {
                const parsed = JSON.parse(payload);
                return typeof parsed === 'object' ? JSON.stringify(parsed, null, 2) : payload;
            } catch {
                return payload;
            }
        }
        return payload;
    }

    try {
        return JSON.stringify(payload, null, 2);
    } catch {
        return String(payload);
    }
};

export const getTransactionLogTypeLabel = (t: TFunction, typeName?: string | null) => {
    if (!typeName) {
        return '-';
    }

    return t(`transactionLogType.${typeName}`, {
        defaultValue: typeName
    });
};
